/* Keep native Shopify localization forms unambiguous when a choice is submitted. */
(() => {
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const choice = event.submitter;
    if (!(form instanceof HTMLFormElement) || !form.action.endsWith('/localization')) return;
    if (!choice || !['language_code', 'locale_code', 'country_code'].includes(choice.name)) return;
    // The clicked button already submits the new value. Exclude the stale hidden value.
    form.querySelectorAll(`input[type="hidden"][name="${choice.name}"]`).forEach((input) => {
      input.disabled = true;
      input.dataset.ftlLocalizationDisabled = 'true';
    });
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('input[data-ftl-localization-disabled]').forEach((input) => {
      input.disabled = false;
      delete input.dataset.ftlLocalizationDisabled;
    });
  });
})();
